import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../api/supabase';

export default function MobileInvoices() {
  const navigate = useNavigate();
  const [q, setQ] = useState('');
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    let query = supabase.from('invoices')
      .select('id, invoice_number, status, total_amount, created_at, clients(full_name)')
      .neq('status', 'VOID')
      .order('created_at', { ascending: false })
      .limit(40);
    if (q) query = query.or(`invoice_number.ilike.%${q}%`);
    const { data } = await query;
    setRows(data || []);
    setLoading(false);
  }, [q]);

  useEffect(() => { load(); }, [load]);

  const STATUS_COLOR = { PAID: '#16a34a', VOID: '#dc2626' };

  return (
    <div style={{ padding: '20px 16px', paddingBottom: 80 }}>
      <div style={{ fontSize: 20, fontWeight: 800, color: '#1a1a2e', marginBottom: 16 }}>Invoices</div>
      <input
        className="form-input"
        placeholder="Search invoice number…"
        value={q}
        onChange={e => setQ(e.target.value)}
        style={{ marginBottom: 16, fontSize: 15 }}
      />
      {loading ? (
        <div style={{ textAlign: 'center', padding: 40, color: '#aaa' }}>Loading…</div>
      ) : (
        <div style={{ background: 'white', borderRadius: 12, overflow: 'hidden', boxShadow: '0 1px 6px rgba(0,0,0,0.06)' }}>
          {rows.length === 0 && <div style={{ padding: '24px 16px', color: '#aaa', fontSize: 13, textAlign: 'center' }}>No invoices found</div>}
          {rows.map((inv, i) => (
            <div key={inv.id} onClick={() => navigate(`/invoices/${inv.id}`)}
              style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px', borderBottom: i < rows.length - 1 ? '1px solid #f3f3f3' : 'none', cursor: 'pointer' }}>
              <div>
                <div style={{ fontWeight: 700, fontSize: 14, color: '#f07040' }}>{inv.invoice_number}</div>
                <div style={{ fontSize: 13, color: '#555', marginTop: 3 }}>{inv.clients?.full_name}</div>
                <div style={{ fontSize: 11, color: '#aaa', marginTop: 2 }}>{inv.created_at?.slice(0, 10)}</div>
              </div>
              <div style={{ textAlign: 'right' }}>
                {inv.status && STATUS_COLOR[inv.status] && (
                  <div style={{ fontSize: 11, fontWeight: 700, color: STATUS_COLOR[inv.status], marginBottom: 4 }}>{inv.status}</div>
                )}
                <div style={{ fontSize: 13, fontWeight: 600, color: '#1a1a2e' }}>
                  {parseFloat(inv.total_amount || 0).toLocaleString()}
                </div>
                <div style={{ fontSize: 11, color: '#bbb', marginTop: 2 }}>View →</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
